import {
  TabItem,
  TabsWrapper,
} from 'modules/Roles/Partials/StatusTabs/Style/style'
import React from 'react'
const StatusTabs = ({ selected, selectedType }) => {
  const selectiontype = selected

  return (
    <TabsWrapper>
      <TabItem
        isActive={selectiontype == 'All'}
        onClick={() => {
          selectedType('All')
        }}
      >
        All
      </TabItem>
      <TabItem
        isActive={selectiontype == 'AcceptedRoles'}
        onClick={() => {
          selectedType('AcceptedRoles')
        }}
      >
        Accepted Roles
      </TabItem>
      <TabItem
        isActive={selectiontype == 'Saved'}
        onClick={() => {
          selectedType('Saved')
        }}
      >
        Saved
      </TabItem>
    </TabsWrapper>
  )
}

export default StatusTabs
